import { ColumnType } from "antd/es/table";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { TooltipComponent } from "../../components/Component";

const TaskReassignmentReportsList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { id: projectId, projectName } = location.state || {};

  // Scroll to top when component mounts or when navigating to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const columns: ColumnType<any>[] = [
    {
      title: "Task Name",
      dataIndex: "taskName",
      key: "taskName",
      width: 150,
      render(text: any, record: any) {
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`task-${record?.taskId}`}
              onClick={() => {
                console.log("Task Name Clicked:");
                navigate(`/pms/project/task-detail/${record.taskId}`, {
                  state: {
                    projectId,
                    projectName,
                    returnPath: location.pathname,
                    returnState: location.state,
                  },
                });
              }}
            >
              {text}
            </span>
            <TooltipComponent
              iconClass="info-circle text-info"
              icon={""}
              id={`task-${record?.taskId}`}
              direction="right"
              text={"Click To View " + text + " Details"}
              containerClassName={"mt-1"}
            />
          </>
        );
      },
    },
    {
      title: "Orginally Assigned To",
      dataIndex: "originallyAssignedTo",
      key: "originallyAssignedTo",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Reassigned To",
      dataIndex: "reassignedToName",
      key: "reassignedToName",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Reason for Change",
      dataIndex: "reassignedReason",
      key: "reassignedReason",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Date of Reassignment",
      dataIndex: "reassignedDate",
      key: "reassignedDate",
      width: 150,
      render: (text: string) => text || "N/A"
    },
    {
      title: "Status",
      dataIndex: "taskStatus",
      key: "taskStatus",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
  ];

  useEffect(() => {
    dispatch(
      updateMenuData([
        {
          text: "Task Reassignment Report",
          link: "pms/task-reassignment-reports-list",
        },
      ])
    );
  }, []);

  return (
    <>
      <Template1
        moduleKey={window.location.pathname}
        columns={columns}
        pageTitle="Task Reassignment Report"
        pageDescription=""
        previousPath={{
          link: "/pms/project/reports",
          state: location.state,
        }}
        filters={{
          defaultFilters: {
            dateRange: {
              title: "Planned Start Date",
            },
          },
        }}
      />
    </>
  );
};

export default TaskReassignmentReportsList;
